import * as Illustrations from "./illustrations";

export const Illustration = Illustrations;
